export const PERMS = {
    READ: 'report_carrier_results.read',
    EXPORT: 'report_carrier_results.export',
}
